module.exports = __webpack_public_path__ + "img/app_single_site.d4832be4.svg";